import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex flex-col items-center justify-center text-center p-4">
      <Helmet>
        <title>404 - Page Not Found | SErraND</title>
        <meta
          name="description"
          content="The page you're looking for doesn't exist. Explore trusted service providers in Kenya with SErraND."
        />
      </Helmet>
      <h1 className="text-6xl font-bold text-blue-600 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-800 mb-6">Page Not Found</h2>
      <p className="text-gray-600 mb-8">
        Oops! The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        className="bg-blue-600 text-white px-6 py-3 rounded-full hover:bg-blue-700 transition-colors"
      >
        Back to Home
      </Link>
    </div>
  );
}

export default NotFound;
